import { AnimateText } from "~/components/elements/AnimateText/AnimateText"
import { HtmlRenderer } from "~/components/primitives/HtmlRenderer"

import type { CapabilityLongItem } from "./CapabilitiesLong.interface"
import s from "./CapabilitiesLongRow.module.scss"

export const CapabilitiesLongRow = ({
  item,
  index,
  showIndex,
  textAlignment,
}: {
  item: CapabilityLongItem
  index: number
  showIndex: boolean
  textAlignment: string
}) => {
  return (
    <div className={s.row} data-text-align={textAlignment}>
      {showIndex && (
        <span className={s.indexNumber} aria-hidden="true">
          {String(index + 1).padStart(2, "0")}
        </span>
      )}
      {item.title && (
        <AnimateText
          element="h3"
          data-large={showIndex || undefined}
          className={s.itemTitle}
        >
          {item.title}
        </AnimateText>
      )}
      {item.description && (
        <HtmlRenderer
          animate
          html={item.description}
          element="div"
          className={s.itemDescription}
        />
      )}
      {item.includesList && (
        <div className={s.includesList}>
          <HtmlRenderer
            html={item.includesList}
            element="div"
            className={s.includesListContent}
          />
        </div>
      )}
    </div>
  )
}
